import React from "react";
import { useAppContext } from "../../context/AppContext";
import { ShopTrans } from "../../utils/translations";
import ShopCard from "../utilPages/ShopCard";

export default function Shop() {
  const { language } = useAppContext();

  const shopData = [
    { image: "https://sporttrade.kz/images/detailed/2/8b858425-9ade-42bf-8c41-a7b8ce710454.jpg", name: ShopTrans[language].yogaMat, price: "75 ₪" },
    { image: "https://www.smallflower.com/cdn/shop/products/25226-DEFAULT-L.jpg?v=1762274339", name: ShopTrans[language].incenseSticks, price: "15 ₪"},
    { image: "https://i.pinimg.com/564x/65/df/99/65df9954989af65bfb3afe802febede7.jpg", name: ShopTrans[language].henna, price: "15 ₪" },
    { image: "https://cdn.kasta.ua/image/1035/s3/3/b7/153/9099603/25729848/25729848_original.jpeg", name: ShopTrans[language].blocks, price: "30 ₪" },
  ];

  return (
    <main className="flex min-h-screen flex-col lg:border-t-[1.5px] border-black lg:mt-5 mb-24">
      <div className="w-full text-center pt-16 lg:pt-10">
        <h2 className="w-fit mx-auto">{ShopTrans[language].header}</h2>
        <p className="text-lg text-gray-600 mt-2 mx-auto max-w-xl">
          {ShopTrans[language].description}
        </p>
      </div>
      
      <div className="flex items-center w-11/12 mx-auto lg:mt-3">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-8 w-full p-4">
          {shopData.map((item, index) => (
            <ShopCard key={index} item={item} /> // Use the ShopCard component
          ))}
        </div>
      </div>
    </main>
  );
}
